"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("../../theme/types");
const Box_1 = require("../Box");
const Component = (0, styled_components_1.default)(Box_1.Box)(({ justify, align, dir, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (theme.FLEX || {})), { display: 'flex' }), (justify && { justifyContent: types_1.propValueMap[justify] || justify })), (align && { alignItems: types_1.propValueMap[align] || align })), (dir && { flexDirection: dir }))));
const Flex = (props) => {
    return (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props), void 0);
};
exports.Flex = Flex;
//# sourceMappingURL=Flex.js.map